import { createReducer, on } from '@ngrx/store';
import { authActionTypes } from './auth.actions';
import { AuthResponse } from '../interfaces/auth-response.interface';
import { APIError } from '../../shared/interfaces/api-error.interface';

export interface AuthState {
  isFetching: boolean;
  tokens: AuthResponse;
  error: APIError;
}

export const initialState: AuthState = {
  isFetching: false,
  tokens: {
    accessToken: null,
    refreshToken: null,
    expiresIn: null,
  },
  error: {
    statusCode: null,
    error: null,
    message: null,
  },
};

export const authReducer = createReducer(
  initialState,
  on(authActionTypes.loginUserRequest, (state) => {
    return {
      ...state,
      isFetching: true,
    };
  }),
  on(authActionTypes.loginUserSuccess, (state, action) => {
    return {
      ...state,
      isFetching: false,
      tokens: action.response,
    };
  }),
  on(authActionTypes.loginUserFailure, (state, action) => {
    return {
      ...state,
      isFetching: false,
      error: action.response,
    };
  })
);
